import isArray from 'lodash/isArray';

export const FEATURE_SWITCHERS_GLOBAL_NAMESPACE = '_adobeTargetExperimentFeatures';

export const isAdobeTargetFeatureEnabled = (feature) => {
  const features = window[FEATURE_SWITCHERS_GLOBAL_NAMESPACE];
  return isArray(features) && features.includes(feature);
};
